import type { Locale } from '../types';

export const EN_US_LOCALE: Locale = {
  locale: 'en_US',

  预览: 'Preview',
  编辑: 'Edit',

  已缓存在本地: 'Save to localStorage',

  导入配置: 'Import config',
  复制配置: 'Copy config',
  导出图片: 'Download Image',
  保存简历: 'Save ResumneInfo',
  '下载 PDF': 'Download pdf',
  进行配置: 'Enter config',
  选择模板: 'Choose template',
  配置简历: 'Config resume',
  确认删除: 'Confirm delete',
  继续添加: 'Continue add',
  提交: 'Submit',
  主题色: 'Brand color',
  'tag 标签色': 'Tag color',

  工作经验: 'Work experience',
  自我介绍: 'Introduction',
  教育背景: 'Educational background',
  个人作品: 'Personal works',
  专业技能: 'Professional skills',
  更多信息: 'More informations',
  工作经历: 'Work experience',
  项目经历: 'Project experience',
  项目描述: 'Description',
  主要工作: 'Main work',
  至今: 'to present',
  访问链接: 'link',

  头像设置: 'Avatar',
  个人信息: 'Personal infomation',
  个人技能: 'Personal skills',

  隐藏头像: 'Hide avatar',
  姓名: 'Fullname',
  手机号码: 'Mobile',
  邮箱: 'Email',
  知乎: 'Zhihu',
  职位: 'Position title',
  期望工作地: 'work space',
  起始时间: 'Start time',
  学校: 'School',
  专业: 'Major in',
  项目名称: 'Project name',
  担任角色: 'Project role',
  部门: 'Apartment',
  公司名称: 'Compare name',
  职位或描述: '',
  作品名称: 'Work name',
  作品链接: 'Work link',
  作品描述: 'Work description',
  技能项: 'Skill',
  技能描述: 'Skill description',
  掌握程度: 'Degree of mastery',
  奖项内容: 'Awards description',
  获奖时间: 'Awards time',

  '默认模板(适用于单页)': 'Default template, apply to single page',
  简易模板: 'Simple template',
  '简易模板(适用于多页)': 'Simple template, apply to multiple page',

  '移动端模式下，只支持预览，不支持配置': '',
  '移动端只提供查看功能，在线制作请前往 PC 端': '',
  上传配置已应用: '',
  '上传文件有误，请重新上传': '',
  '您当前浏览器不支持 FileReader，建议使用谷歌浏览器': '',
  '编辑模式下, 切换国际化会导致配置内容丢失，请及时保存': '',
  进入在线编辑: '',
  获取简历信息失败: '',
  确定: 'Ok',

  '无用户信息模式下，不允许预览': '',
};
